import { createFileRoute, Outlet } from "@tanstack/react-router";

// Layout-only route. The /blog index page lives in `blog.index.tsx` so that
// child routes (e.g. /blog/$slug) don't inherit a stale canonical/hrefLang
// link tag from this parent (Semrush flagged duplicates as "non-canonical").
export const Route = createFileRoute("/blog")({
  component: () => <Outlet />,
});
